import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 mb-4">
          准备好加入1024社区了吗？
        </h2>
        <p className="text-foreground-600 text-base mb-8 max-w-xl mx-auto">
          与百万开发者一起学习、交流、成长。无论你是编程新手还是资深架构师，1024社区都有属于你的一片天地。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/frontend"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-all whitespace-nowrap text-base"
          >
            立即探索文章
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-background-50 hover:bg-background-100 text-foreground-800 font-semibold rounded-lg border border-background-300/60 transition-all whitespace-nowrap text-base"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}